class SiteHelperCollapsable
    extends QueryElement<HTMLElement> {
    
    constructor(elem: HTMLElement) {
        super(elem);

        this.on('mousedown', (e) => {
            if(e.target == e.currentTarget)
                this.toggleClass('collapsed');
        });
    }

    expand() {
        this.removeClass('collapsed');
    }
    collapse() {
        this.addClass('collapsed');
    }
}